export default "__VITE_ASSET__DPRIIt7X__"